import { createFileRoute, redirect } from "@tanstack/react-router";
import { Auth } from "@/components/auth/auth";

const validPaths = new Set([
  "sign-in",
  "sign-up",
  "forgot-password",
  "reset-password",
  "sign-out",
  "verify-email",
]);

export const Route = createFileRoute("/auth/$path")({
  beforeLoad: ({ params }) => {
    if (!validPaths.has(params.path)) {
      throw redirect({ to: "/" });
    }
  },
  component: AuthPage,
});

function AuthPage() {
  const { path } = Route.useParams();

  return (
    <div className="flex min-h-svh items-center justify-center p-4">
      <div className="flex w-full max-w-sm flex-col items-center gap-6">
        <div className="flex flex-col items-center gap-3">
          <img src="/favicon.svg" alt="Provender" className="h-10 w-10" />
          <span className="font-heading text-2xl font-semibold tracking-tight">
            Provender
            {import.meta.env.VITE_APP_ENV !== "production" &&
              ` [${import.meta.env.VITE_APP_ENV}]`}
          </span>
        </div>
        <Auth path={path} className="w-full" />
      </div>
    </div>
  );
}
